import { Link } from 'react-router-dom';
import { ArrowLeft, Server } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';
import { SEOHead } from '@/components/SEOHead';
import { useTranslation } from '@/lib/i18n';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <Layout>
      <SEOHead title={t('common.notFoundTitle')} noindex={true} />
      <div className="section-spacing flex flex-col items-center justify-center text-center">
        <Server className="w-16 h-16 text-muted-foreground mb-6" />
        <h1 className="text-3xl font-black mb-4">{t('common.notFoundTitle')}</h1>
        <p className="text-muted-foreground mb-8">{t('common.notFoundDesc')}</p>
        <Link to="/">
          <Button className="bg-primary hover:bg-primary/90">
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t('common.backHome')}
          </Button>
        </Link>
      </div>
    </Layout>
  );
}
